import { PostProperties } from "../types";
import image from "../img/lostGemBasMooy.jpg";

const post: PostProperties = {
  id: 29,
  title: "Bas Mooy - Strictly Techno, Waterfront Rotterdam (14.09.2007)",
  content: `Bas Mooy is a Dutch techno DJ and producer renowned for his hard-hitting and hypnotic approach. Known for his deep, industrial sounds, Mooy's sets are a masterclass in driving, relentless rhythms and intricately layered tracks. In this live mix, recorded at Waterfront Rotterdam in 2007, Mooy showcases his signature style—dark, atmospheric beats paired with intense, bass-heavy kicks and minimalistic melodies that maintain a relentless energy throughout.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/bas-mooy-live-strictly-techno-14092007",
  category: "Lost Gem",
  translationsBg: {
    content: `Bas Mooy е холандски техно диджей и продуцент, известен със своя мощен и хипнотичен подход. Известен с дълбоките си, индустриални звуци, сетовете на Муй са майсторски клас по драйв, безмилостни ритми и сложно наслоени парчета. В този микс на живо, записан във Waterfront Rotterdam през 2007 г., Муй демонстрира своя емблематичен стил - мрачни, атмосферни бийтове, съчетани с интензивни, басови ритъми и минималистични мелодии, които поддържат безмилостна енергия през цялото време.`,
  },
};

export default post;
